import React, { memo, useRef, useState } from "react";
import { OverlayTrigger } from "react-bootstrap";
import type { Editor } from "slate";
import { useCopyToClipboard, useOnClickOutside } from "usehooks-ts";

import { useEditorPopupContext } from "../../../contexts/editorPopupsContext";
import { CopyIcon, UnLinkIcon } from "../../icons";
import { EditIcon } from "../../icons/EditIcon";
import { renderTooltip } from "../../StyledTooltip/StyledTooltip";
import { Helpers } from "../helpers";

export interface IProps {
  url: string;
  editor: Editor;
  closePopup: () => void;
  setAsPrepareLink: () => void;
}

const ManageLinkComponent: React.FC<IProps> = memo(
  ({ closePopup, editor, url, setAsPrepareLink }) => {
    const { setUrl } = useEditorPopupContext();
    const [_copiedText, copy] = useCopyToClipboard();
    const [isCopied, setIsCopied] = useState(false);
    const ref = useRef(null);

    const editLink = () => {
      setUrl(url);
      setAsPrepareLink();
    };

    const linkButton = document.getElementById("linkButton");

    useOnClickOutside([ref, { current: linkButton }], () => {
      closePopup();
    });

    const copyLink = async () => {
      await copy(url).then(() => {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1500);
      });
    };

    const unlink = () => {
      closePopup();
      Helpers.unwrapLink(editor);
    };

    return (
      <div ref={ref} className="d-flex justify-content-between ">
        <div className="link-manager__link-container">
          <a href={url} target="_blank" rel="noreferrer">
            {url}
          </a>
        </div>
        <div className="link-manager__button-container">
          <button data-testid="editButton" onClick={editLink}>
            <EditIcon />
          </button>
          <OverlayTrigger
            show={isCopied}
            container={ref}
            overlay={renderTooltip(<span>Copied!</span>)}
          >
            <button onClick={copyLink} data-testid="copyButton">
              <CopyIcon />
            </button>
          </OverlayTrigger>

          <button onClick={unlink} data-testid="unlinkButton">
            <UnLinkIcon />
          </button>
        </div>
      </div>
    );
  },
);

export { ManageLinkComponent };
